export interface SavedCompanion {
  person_name: PersonName;
  birthdate?: string;
  canada_travel_number?: string;
  gender?: string;
  known_traveler_number?: string;
  loyalty_member_id: string;
  loyalty_program_carrier_code: string;
  redress_number?: string;
  sequence_number: string;
  sfpd_match: boolean;
  sfpd_on_file: boolean;
}

export interface PersonName {
  first_name: string;
  last_name: string;
  middle_name?: string;
  name_prefix?: string;
  name_suffix?: string;
  preferred_name?: string;
}

export interface SavedCompanionResponse {
  data: CampanionData;
}

export interface CampanionData {
  companions: SavedCompanion[];
}
